import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        welcome: `Welcome to ${ COMMON.appName }`,
        instructions: `${ COMMON.appName } is the world's first evidence board NFT generator. 
        We're aiming to rectify the injustice in the world by making it easier to 
        persist and distribute information.
        &nbsp;
        Hold them accountable.
        &nbsp;`,
        needHelp: 'Need help getting started?'
    }
}

export default TRANSLATIONS